import React from 'react'

export default props => (
    <div className='row'>
		<div className='col col-md-12'>
			{props.children}
		</div>
	</div>
)
